import { Box, Flex, Text } from '@chakra-ui/layout';
import NotFound from '@duke-hq/ui/components/NotFound/WomanOnPhone';
import { Trans } from '@lingui/react/macro';

export function NotFoundError() {
  return (
    <Flex direction="column" align="center" justify="center">
      <Box>
        <NotFound />
      </Box>
      <Text mt={4} fontSize="2xl" fontWeight="semi-bold" textStyle="fg.default">
        <Trans>Page not found</Trans>
      </Text>
      <Text mt={4} fontSize="lg" textStyle="fg.default">
        <Trans>Sorry, we can't find that page.</Trans>
      </Text>
      <Text fontSize="lg" textStyle="fg.default">
        <Trans>It might be an old link or that access is restricted.</Trans>
      </Text>
    </Flex>
  );
}
